import React, { useState, useEffect, useRef } from "react";
import API_BASE_URL from "../../../config";
import "../../../assets/CSS/images.css";
import { expandEmbeds, expandImages } from "./images";
import { handleDownload } from "./handleFileDownload";
import enableTableSearch from "../../../utility/table";

function DateReportTable({ query, setLoader }) {
  const [report, setReport] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [images, setImages] = useState([]);
  const imgLen = useRef(0);

  const tableRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    if (
      query.startDate === "" ||
      query.endDate === "" ||
      query.letterType === null
    ) {
      setReport(false);
      return;
    }
    fetch(
      `${API_BASE_URL}/api/date-range-report?startDate=${query.startDate}&endDate=${query.endDate}&letterType=${query.letterType}&subject=${query.subject}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          alert(data.error);
          setLoader(false);
          setReport(false);
          return;
        }
        setReportData(data.data);
        setImages(data.images);

        setLoader(false);
        setReport(true);
      })
      .catch((err) => {
        console.error("Error fetching entries:", err);
        setLoader(false);
        setReport(false);
        return;
      });
  }, [query]);

  useEffect(() => {
    if (images.length > 0 && imgLen.current !== images.length) {
      expandImages();
      expandEmbeds();
      imgLen.current = images.length;
    }
  }, [images]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 0,
      noDataText: "No Letter found",
    });

    return cleanup;
  }, [reportData]);

  return (
    <div id="table-container">
      {report && (
        <>
          <div id="table-actions">
            <div className="search-box" style={{ marginTop: "2%" }}>
              <label>Search:</label>
              <input type="text" id="search" name="search" ref={inputRef} />
            </div>
          </div>
          <table id="letter-wise-report" ref={tableRef}>
            <thead>
              <tr>
                <th>Letter Number</th>
                <th>Letter Date</th>
                <th>Division</th>
                <th>Range</th>
                <th>Subject</th>
                <th>File</th>
                <th>Source</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((item, index) => (
                <tr key={index}>
                  <td>{item[3]}</td>
                  <td>{new Date(item[4]).toLocaleDateString()}</td>
                  <td>{item[1]}</td>
                  <td>{item[2]}</td>
                  <td>{item[5]}</td>
                  <td>
                    {images[index] !== null &&
                    images[index].startsWith("data:application/pdf") ? (
                      <div className="embed-wrapper">
                        <embed
                          src={images[index]}
                          width="100%"
                          height="400"
                          type="application/pdf"
                        />
                        <div className="overlay"></div>
                      </div>
                    ) : images[index] !== null &&
                      images[index].startsWith("data:image/") ? (
                      <img src={images[index]} alt="Uploaded" />
                    ) : null}
                  </td>
                  <td>{item[7]}</td>
                  <td>
                    <button
                      onClick={() =>
                        handleDownload(images[index], `${item[3]}`)
                      }
                      style={{
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "18px",
                      }}
                    >
                      <i className="fa fa-download"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default DateReportTable;
